export const translations = {
  it: {
    nav: {
      services: "Servizi",
      experience: "Esperienza",
      method: "Metodo",
      founder: "Founder",
      contact: "Contatti",
      cta: "Contattaci",
    },
    hero: {
      overline: "Consulenza IT Corporate",
      title: "Rendiamo i servizi IT più organizzati, misurabili ed efficienti.",
      subtitle:
        "ADR 4 Solutions supporta aziende e organizzazioni strutturate nella governance operativa di service desk, end user support, processi di ticketing, reporting e coordinamento team IT.",
      slogan: "IT solutions. Real results.",
      ctaPrimary: "Contattaci",
      ctaSecondary: "Scopri i servizi",
    },
    about: {
      overline: "Chi siamo",
      title: "Consulenza IT corporate per processi, team e servizi più efficienti.",
      p1: "ADR 4 Solutions è una realtà consulenziale agile, specializzata in IT Operations, governance operativa dei servizi IT, end user support e ottimizzazione dei processi.",
      p2: "Aiutiamo aziende, società di consulenza e organizzazioni strutturate a rendere i servizi IT più chiari, governabili e misurabili, intervenendo su procedure, flussi di ticketing, reporting, coordinamento operativo e qualità del servizio agli utenti finali.",
    },
    services: {
      overline: "Cosa facciamo",
      title: "Servizi",
      subtitle:
        "Interveniamo su processi, team, strumenti e procedure per rendere il servizio IT più organizzato, leggibile e controllabile.",
      items: [
        {
          title: "IT Operations & Governance",
          desc: "Supporto nella gestione operativa dei servizi IT, con focus su processi, responsabilità, flussi, performance e controllo del servizio.",
        },
        {
          title: "End User Support",
          desc: "Ottimizzazione dei servizi rivolti agli utenti finali, dalla presa in carico delle richieste alla gestione delle escalation e delle priorità operative.",
        },
        {
          title: "Service Desk & Ticketing",
          desc: "Analisi e miglioramento dei flussi di ticketing, delle procedure operative, dei gruppi di supporto e dei processi fuori flusso.",
        },
        {
          title: "Reporting & Performance Control",
          desc: "Creazione e lettura di report operativi per monitorare volumi, SLA, survey, criticità ricorrenti e aree di miglioramento.",
        },
        {
          title: "Team Coordination & Procedures",
          desc: "Supporto nella strutturazione di team tecnici, procedure, ruoli, priorità operative e modalità di comunicazione tra gruppi.",
        },
        {
          title: "IT Transition & Migration Support",
          desc: "Supporto operativo durante fasi di migrazione, transizione, riorganizzazione IT e cambiamento degli strumenti aziendali.",
        },
      ],
    },
    experience: {
      overline: "Esperienza",
      title: "Esperienza in contesti corporate complessi",
      p1: "ADR 4 Solutions nasce da un background maturato in realtà corporate del settore automotive, financial services e mobility, con attività svolte in ecosistemi collegati a FCA / Stellantis, CA Auto Bank, Drivalia e Leasys.",
      p2: "Un'esperienza costruita su processi IT strutturati, service desk, end user support, portali di ticketing, reporting operativo, migrazioni aziendali, gestione utenze, coordinamento di team tecnici e miglioramento continuo dei servizi.",
      blocks: [
        "Corporate IT environments",
        "Service Desk Operations",
        "End User Support",
        "Reporting & SLA Analysis",
        "Team Coordination",
        "IT Migration Support",
      ],
      disclaimer:
        "I marchi citati fanno riferimento a esperienze professionali pregresse e/o contesti aziendali nei quali sono state maturate competenze operative e consulenziali.",
    },
    method: {
      overline: "Metodo",
      title: "Un approccio operativo, non teorico.",
      intro1:
        "ADR 4 Solutions lavora partendo dalla realtà quotidiana dei team IT: ticket, richieste, escalation, utenti, strumenti, procedure e criticità operative.",
      intro2:
        "L'obiettivo è trasformare l'operatività in un sistema più leggibile, organizzato e controllabile, aiutando l'azienda a prendere decisioni migliori e a migliorare la qualità del servizio.",
      steps: [
        {
          title: "Analisi del contesto operativo",
          desc: "Comprensione dei processi esistenti, dei flussi di ticketing, dei gruppi coinvolti e delle principali criticità.",
        },
        {
          title: "Razionalizzazione dei processi",
          desc: "Individuazione di colli di bottiglia, fuori flusso, passaggi non chiari e aree migliorabili.",
        },
        {
          title: "Supporto operativo ai team",
          desc: "Affiancamento nella gestione delle attività quotidiane, delle priorità e delle comunicazioni tra gruppi tecnici.",
        },
        {
          title: "Reporting e controllo",
          desc: "Creazione di viste, report e dashboard utili a leggere l'andamento del servizio e supportare decisioni più consapevoli.",
        },
        {
          title: "Miglioramento continuo",
          desc: "Azioni concrete per aumentare efficienza, qualità percepita e governabilità del servizio IT.",
        },
      ],
    },
    audience: {
      overline: "Per chi lavoriamo",
      title: "A chi ci rivolgiamo",
      intro:
        "ADR 4 Solutions si rivolge ad aziende, società di consulenza, system integrator e organizzazioni strutturate che necessitano di supporto nella gestione e ottimizzazione dei servizi IT.",
      items: [
        "Aziende corporate",
        "Società di consulenza IT",
        "System integrator",
        "Service provider",
        "Organizzazioni con service desk interni o esternalizzati",
        "Realtà con team tecnici da strutturare o riorganizzare",
        "Aziende in fase di migrazione o transizione IT",
      ],
    },
    why: {
      overline: "Perché ADR 4 Solutions",
      title: "Metodo, ordine e visibilità nei servizi IT.",
      p1: "Conosciamo le dinamiche reali dei servizi IT aziendali: la pressione operativa, i volumi di ticket, le urgenze degli utenti, le complessità dei sistemi, il coordinamento tra team e la necessità di fornire dati chiari ai referenti aziendali.",
      p2: "Portiamo metodo, ordine e visibilità dove spesso ci sono flussi frammentati, procedure non aggiornate e attività difficili da misurare.",
      cards: [
        {
          title: "Processi più chiari",
          desc: "Flussi operativi razionalizzati e procedure aggiornate per ridurre i fuori flusso e migliorare la leggibilità del servizio.",
        },
        {
          title: "Team più coordinati",
          desc: "Ruoli, priorità e modalità di comunicazione strutturate tra gruppi tecnici, supporto e referenti di business.",
        },
        {
          title: "Servizi più misurabili",
          desc: "Report e dashboard operative per leggere volumi, SLA, criticità ricorrenti e supportare decisioni consapevoli.",
        },
      ],
    },
    founder: {
      overline: "Founder",
      title: "Founder & IT Consultant",
      name: "Alessandro Di Rienzo",
      p1: "ADR 4 Solutions è guidata da Alessandro Di Rienzo, IT Consultant con esperienza in contesti corporate complessi.",
      p2: "Nel corso della sua esperienza ha lavorato su service desk, end user support, portali di ticketing, reporting operativo, coordinamento di gruppi tecnici, gestione utenze, migrazioni IT, fonia aziendale, mobile device management e processi di miglioramento dei servizi.",
      p3: "Questa esperienza ha portato alla nascita di ADR 4 Solutions: una realtà consulenziale pensata per aiutare le aziende a strutturare meglio processi, team e procedure IT.",
    },
    contact: {
      overline: "Contatti",
      title: "Parliamo del tuo progetto IT",
      intro:
        "Hai bisogno di rendere il tuo service desk più efficiente, strutturare meglio i processi o migliorare la governance operativa dei servizi IT?",
      cta: "Contattaci per una consulenza",
      form: {
        name: "Nome",
        company: "Azienda",
        email: "Email",
        phone: "Telefono",
        message: "Messaggio",
        submit: "Invia richiesta",
        sending: "Invio in corso...",
        success: "Richiesta inviata. Ti ricontatteremo a breve.",
        error: "Si è verificato un errore. Riprova o scrivici via email.",
      },
      labels: {
        email: "Email",
        emailAlt: "Email alternativa",
        phone: "Telefono",
        linkedinCompany: "LinkedIn aziendale",
        linkedinPersonal: "LinkedIn personale",
      },
    },
    footer: {
      tagline: "IT solutions. Real results.",
      desc: "Consulenza IT corporate | IT Operations | Service Desk | End User Support | Reporting | Governance",
      rights: "Tutti i diritti riservati.",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      linkedin: "LinkedIn",
    },
  },
  en: {
    nav: {
      services: "Services",
      experience: "Experience",
      method: "Method",
      founder: "Founder",
      contact: "Contact",
      cta: "Contact us",
    },
    hero: {
      overline: "Corporate IT Consulting",
      title: "Bringing structure, measurability and efficiency to corporate IT services.",
      subtitle:
        "ADR 4 Solutions partners with companies and complex organizations to strengthen the operational governance of service desk, end user support, ticketing, reporting and IT team coordination.",
      slogan: "IT solutions. Real results.",
      ctaPrimary: "Get in touch",
      ctaSecondary: "Explore services",
    },
    about: {
      overline: "About",
      title: "Corporate IT consulting for sharper processes, stronger teams and better services.",
      p1: "ADR 4 Solutions is an agile consulting firm focused on IT Operations, the operational governance of IT services, end user support and process optimisation.",
      p2: "We help corporates, consulting firms and structured organisations make IT services clearer, more governable and measurable — working on procedures, ticketing flows, reporting, operational coordination and the quality of service delivered to end users.",
    },
    services: {
      overline: "What we do",
      title: "Services",
      subtitle:
        "We work on processes, teams, tools and procedures to make IT services more organised, readable and under control.",
      items: [
        {
          title: "IT Operations & Governance",
          desc: "Hands-on support in running IT services — with a clear focus on processes, accountability, workflows, performance and service control.",
        },
        {
          title: "End User Support",
          desc: "Streamlining end user services, from request intake to escalation handling and operational priority management.",
        },
        {
          title: "Service Desk & Ticketing",
          desc: "Reviewing and improving ticketing flows, operational procedures, support groups and out-of-flow processes.",
        },
        {
          title: "Reporting & Performance Control",
          desc: "Building and reading operational reports to monitor volumes, SLAs, surveys, recurring issues and improvement areas.",
        },
        {
          title: "Team Coordination & Procedures",
          desc: "Structuring technical teams, procedures, roles, operational priorities and communication between groups.",
        },
        {
          title: "IT Transition & Migration Support",
          desc: "Operational support across migrations, transitions, IT reorganisations and changes in business tools.",
        },
      ],
    },
    experience: {
      overline: "Experience",
      title: "Built in complex corporate environments",
      p1: "ADR 4 Solutions draws on a background built inside corporate environments across automotive, financial services and mobility — with hands-on work in ecosystems connected to FCA / Stellantis, CA Auto Bank, Drivalia and Leasys.",
      p2: "An experience shaped by structured IT processes, service desk, end user support, ticketing portals, operational reporting, corporate migrations, user management, technical team coordination and continuous service improvement.",
      blocks: [
        "Corporate IT environments",
        "Service Desk Operations",
        "End User Support",
        "Reporting & SLA Analysis",
        "Team Coordination",
        "IT Migration Support",
      ],
      disclaimer:
        "The brands mentioned refer to prior professional engagements and corporate environments in which operational and consulting expertise was developed.",
    },
    method: {
      overline: "Method",
      title: "Hands-on, not theoretical.",
      intro1:
        "ADR 4 Solutions starts from the daily reality of IT teams: tickets, requests, escalations, users, tools, procedures and operational friction.",
      intro2:
        "The goal is to turn day-to-day operations into a more readable, organised and controllable system — supporting better decisions and a higher quality of service.",
      steps: [
        {
          title: "Operational context review",
          desc: "Mapping existing processes, ticketing flows, the groups involved and the most relevant operational issues.",
        },
        {
          title: "Process rationalisation",
          desc: "Identifying bottlenecks, out-of-flow steps, unclear handoffs and concrete areas for improvement.",
        },
        {
          title: "Operational support to teams",
          desc: "Working alongside teams on daily activities, priorities and communication between technical groups.",
        },
        {
          title: "Reporting and control",
          desc: "Creating the views, reports and dashboards needed to read service performance and support informed decisions.",
        },
        {
          title: "Continuous improvement",
          desc: "Concrete actions to lift efficiency, perceived quality and overall governability of the IT service.",
        },
      ],
    },
    audience: {
      overline: "Who we work with",
      title: "Who we serve",
      intro:
        "ADR 4 Solutions works with corporates, consulting firms, system integrators and structured organisations that need support in managing and improving IT services.",
      items: [
        "Corporate companies",
        "IT consulting firms",
        "System integrators",
        "Service providers",
        "Organisations with internal or outsourced service desks",
        "Companies with technical teams to structure or reorganise",
        "Companies in IT migration or transition phases",
      ],
    },
    why: {
      overline: "Why ADR 4 Solutions",
      title: "Method, clarity and visibility for IT services.",
      p1: "We know the real dynamics of corporate IT services: operational pressure, ticket volumes, end user urgencies, system complexity, cross-team coordination and the need to give clear data to business stakeholders.",
      p2: "We bring method, order and visibility where flows are often fragmented, procedures outdated and activities hard to measure.",
      cards: [
        {
          title: "Clearer processes",
          desc: "Streamlined operational flows and up-to-date procedures to reduce out-of-flow events and improve service readability.",
        },
        {
          title: "Better coordinated teams",
          desc: "Defined roles, priorities and communication channels between technical groups, support and business stakeholders.",
        },
        {
          title: "More measurable services",
          desc: "Operational reports and dashboards to read volumes, SLAs, recurring issues and support informed decisions.",
        },
      ],
    },
    founder: {
      overline: "Founder",
      title: "Founder & IT Consultant",
      name: "Alessandro Di Rienzo",
      p1: "ADR 4 Solutions is led by Alessandro Di Rienzo, IT Consultant with hands-on experience in complex corporate environments.",
      p2: "Across his career he has worked on service desk, end user support, ticketing portals, operational reporting, technical team coordination, user management, IT migrations, corporate telephony, mobile device management and service improvement initiatives.",
      p3: "That experience led to ADR 4 Solutions: a consulting firm built to help companies give better structure to IT processes, teams and procedures.",
    },
    contact: {
      overline: "Contact",
      title: "Let's talk about your IT challenge.",
      intro:
        "Looking to make your service desk more efficient, give better structure to your processes or strengthen the operational governance of your IT services?",
      cta: "Get in touch for an initial conversation",
      form: {
        name: "Name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send request",
        sending: "Sending...",
        success: "Request sent. We'll get back to you shortly.",
        error: "Something went wrong. Please try again or email us directly.",
      },
      labels: {
        email: "Email",
        emailAlt: "Alternative email",
        phone: "Phone",
        linkedinCompany: "Company LinkedIn",
        linkedinPersonal: "Personal LinkedIn",
      },
    },
    footer: {
      tagline: "IT solutions. Real results.",
      desc: "Corporate IT Consulting · IT Operations · Service Desk · End User Support · Reporting · Governance",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      linkedin: "LinkedIn",
    },
  },
};
